module.exports = __webpack_public_path__ + "img/fish-filet-2.36a77d59.png";